import React, { useState } from 'react';
import { Modal, Button, Space, Typography, Tooltip, message } from 'antd';
import api from '../api';

// One Campaign Update to read: topic, dates, description, links -- and, when
// it is waiting for the viewer's acknowledgement, Acknowledge. That stays off
// until one of the links has been opened (at once if there are none), so the
// update has to be opened to be acknowledged. Used by My Summary's To Do and
// My Hub > My Campaign Updates.
//
// Links opened are remembered for the browser tab (not on the server), so
// opening one in either place counts in both.
const opened = new Set();   // update ids

export default function CampaignUpdateReadModal({ update, canAcknowledge, onClose, onAcknowledged }) {
  const [, rerender] = useState(0);
  const [acking, setAcking] = useState(false);
  if (!update) return null;
  const links = update.Links || [];
  const ready = !links.length || opened.has(update.ID);
  const acknowledge = () => {
    setAcking(true);
    api.post(`/api/campaign-updates/${update.ID}/acknowledge`)
      .then(() => { message.success('Acknowledged.'); onAcknowledged?.(); onClose(); })
      .catch((err) => message.error(err.response?.data?.error || 'Could not acknowledge.'))
      .finally(() => setAcking(false));
  };
  return (
    <Modal open onCancel={onClose} width={640} title={update.Title}
      footer={(
        <Space>
          {/* Says why Acknowledge is greyed out, without needing a hover. */}
          {canAcknowledge && !ready && (
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              Open the link{links.length > 1 ? 's' : ''} above to read the update, then acknowledge.
            </Typography.Text>
          )}
          <Button onClick={onClose}>Close</Button>
          {canAcknowledge && (
            <Tooltip title={ready ? '' : 'Open the update first'}>
              <Button type="primary" disabled={!ready} loading={acking} onClick={acknowledge}>Acknowledge</Button>
            </Tooltip>
          )}
        </Space>
      )}>
      {/* Each labelled; the due date only when acknowledgement is required. */}
      <div style={{ marginBottom: 10 }}>
        <Typography.Text type="secondary" style={{ display: 'block' }}>Date of Update: {update.UpdateDate}</Typography.Text>
        <Typography.Text type="secondary" style={{ display: 'block' }}>
          Acknowledgement Required: {update.AcknowledgementRequired ? 'Yes' : 'No'}
        </Typography.Text>
        {update.AcknowledgementRequired && (
          <Typography.Text type="secondary" style={{ display: 'block' }}>
            Acknowledge Due Date: {update.AckDueDate || '—'}
          </Typography.Text>
        )}
      </div>
      {update.Description && (
        <Typography.Paragraph style={{ whiteSpace: 'pre-wrap' }}>{update.Description}</Typography.Paragraph>
      )}
      {links.map((l) => (
        <div key={l.ID} style={{ marginBottom: 4 }}>
          <a href={l.URL} target="_blank" rel="noopener noreferrer"
            onClick={() => { opened.add(update.ID); rerender((n) => n + 1); }}>
            {l.Label || l.URL}
          </a>
        </div>
      ))}
    </Modal>
  );
}
